// Default debounce tid när vi vill använda oss utav det så att vi får samma känsla i hela systemet
export const DEBOUNCE_DELAY_TIME = 500;

// Moderna browsers tillåter 6 samtida frågor
// https://docs.diffusiondata.com/cloud/latest/manual/html/designguide/solution/support/connection_limitations.html
export const CACHE_IMAGE_THRESHOLD = 6;
